import { useSelector } from "react-redux";
import SearchTermOperationCard from "./SearchTermOperationComponents/SearchTermOperationCard";
import SearchTermOperationTabs from "./SearchTermOperationComponents/SearchTermOperationTabs/SearchTermOperationTabs";
import ScopesSkeleton from "./ScopesTabSkeleton";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import FloatingActionItems from "../../../../pages/FloatingItems/FloatingActionItems";

const SearchTermOperation = () => {
  const {
    isScopesLoading,
    isScopesTabDataFetched,
    selectedSTOperationSharedUid,
  } = useSelector((state: any) => state.searchTermOperation);
  return (
    <div>
      <SearchTermOperationCard />
      {isScopesLoading ? (
        <>
          <ScopesSkeleton />
        </>
      ) : !isScopesLoading && isScopesTabDataFetched ? (
        <>
          <SearchTermOperationTabs />
          <div data-tracker="512">
            <FloatingActionItems
              selectedSiteFloatingAction={selectedSTOperationSharedUid}
              selectedDimensionsFloatingAction=""
              trackIdFloatingAction="513"
            />
          </div>
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Typography
            variant="body2"
            sx={{ mt: 3, textAlign: "center", color: "#888" }}
          >
            No data available. Please select a website, then choose an account,
            and click "Get Data".
          </Typography>
        </Box>
      )}
    </div>
  );
};

export default SearchTermOperation;
